import { CriterionListItem, Quota } from './recruitment';
import { useMutation, useQuery } from 'react-query';
import { queryGet, queryUpdate } from './fetch';
import { SessionQuota } from './session';
import { AxiosError } from 'axios';

export const KnownQuotasRefs = [SessionQuota.ALLOWED_DEVICES_CATEGORY];

export interface QuotaRef {
  ref?: string;
  fieldRef?: string;
  color?: string;
  quotas: NewQuota[] | undefined;
}

export interface NewQuota {
  item: CriterionListItem;
  max?: number;
  value?: number;
  label?: string;
  ref?: string;
  confirmed?: number;
}

export const useQuotas = (
  sessionId?: string,
  refs: string[] | null = [],
  processed: boolean = false,
) => {
  const params = { processed, refs };
  return useQuery<NewQuota[]>(
    ['sessions', sessionId, 'quotas', params],
    queryGet(`/v2/sessions/${sessionId}/quotas`, params),
    {
      enabled: !!sessionId,
    },
  );
};

export const useUpdateQuotas = (sessionId?: string) => {
  return useMutation<NewQuota[], AxiosError, Quota[]>(
    queryUpdate(`/v2/sessions/${sessionId}/quotas`),
  );
};

export const useQuotaExist = (sessionId: string, ref: string) => {
  return useQuery<{ exist: boolean }>(
    ['sessions', sessionId, 'quotas', ref, 'exist'],
    queryGet(`/v2/sessions/${sessionId}/quotas/${ref}/exist`),
    {
      enabled: !!sessionId && !!ref,
    },
  );
};

export const useApplicationsByQuotas = (sessionId: string) => {
  return useQuery(
    ['sessions', sessionId, 'applications-ids-by-quotas'],
    queryGet(`/v2/sessions/${sessionId}/applications-ids-by-quotas`),
    {
      enabled: !!sessionId,
    },
  );
};

export const useHaveQuota = (
  sessionId: string = '',
  ref: string = '',
): boolean => {
  const { data: response } = useQuotaExist(sessionId, ref);

  return !!response?.exist;
};
